import { render, staticRenderFns } from "./VisitPayment.vue?vue&type=template&id=06b9c1a2&scoped=true"
import script from "./VisitPayment.vue?vue&type=script&lang=js"
export * from "./VisitPayment.vue?vue&type=script&lang=js"
import style0 from "./VisitPayment.vue?vue&type=style&index=0&id=06b9c1a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b9c1a2",
  null
  
)

export default component.exports